import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AltinnRequestInterceptor } from '../services/interceptors/altinn-request.interceptor';
import { LoadingInterceptor } from '../services/interceptors/loading.interceptor';


export const HttpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AltinnRequestInterceptor, multi: true }
]
